module.exports = __webpack_public_path__ + "media/images/honey-logo_lg-855ac03ac46ee9c55332e3de0d6d1bcd.png";